import React, {useRef, useState} from 'react';
import {selectSettings} from '../selectSettings';
import styles from './styles';
import axios from 'axios'
import axiosConfig from '../../config/axios.config'
import { checkResponseErrorCodeAndRedirect } from '../../utils/errorHelper'
import {Form} from '@xpertdox_js/xdcomponents';

const Filters = props => {

  const {data, handleSelect} = props;

  const [filterData, setFilterData] = useState([])
  const fetchedFilters = useRef(false);
  const formatOptions = origOptions => {
    return origOptions.map(option => [option.label, option.value]);
  }
  const defaultSettings = {
    labelStyles: {
      display: 'inline-block',
      width: '33.3333%',
      verticalAlign: 'top',
      padding: '0 5px',
      marginBottom: '5px'
    },
    notRequired: true,
  }

  const formSettings = [
    {
      type: 'select',
      options: formatOptions(selectSettings.ageItems),
      id: 'minAge',
      label: 'Min Age',
      ...defaultSettings,
    },
    {
      type: 'select',
      id: 'maxAge',
      options: formatOptions(selectSettings.ageItems),
      label: 'Max Age',
      ...defaultSettings,
    },
    {
      type: 'select',
      options: formatOptions(selectSettings.gender),
      label: 'Gender',
      id: 'gender',
      ...defaultSettings,
    },
    {
      type: 'multiselect',
      options: formatOptions(selectSettings.ecogFormOptions),
      label: 'Performance Status',
      id: 'pscore',
      ...defaultSettings,
    },
    {
      type: 'multiselect',
      options: formatOptions(filterData || []),
      label: 'Mutations: Eligible',
      id: 'mutationsIN',
      ...defaultSettings,
    },
    {
      type: 'multiselect',
      options: formatOptions(filterData || []),
      label: 'Mutations: Not Eligible',
      id: 'mutationsOUT',
      ...defaultSettings,
    }
  ]

  const fetchFilters = () => {
    fetchedFilters.current = true;
    // removed 'axiosConfig.auth' as token is updated on login
    axios.get(`${axiosConfig.apiUrl}/rt/getFilterData?send=DiseaseStage,TreatmentStatus,Mutations,Labs,VitalSigns,LungFunctionTest,PrimaryPurpose,CardiovascularTests`).then(res =>{
      if(res.data.mutations.length > 0){
        let mutationsOptions = res.data.mutations.map(m => ({label:m,value:m}))
        setFilterData(mutationsOptions)
      }
    }).catch((err) => {
      console.log(err)
      checkResponseErrorCodeAndRedirect(err)
    })
  }

  if(filterData.length === 0 && !fetchedFilters.current) fetchFilters()

  const [formState, setFormState] = useState({});
  const currentForm = useRef({});
  if (formState !== {})
  Object.keys(formState).forEach(key => {
    if (currentForm.current[key] !== formState[key]) {
      let filtersSelected = [];
      (selectSettings[
        key === 'minAge' || key === 'maxAge' ? 'ageItems'
        : key === 'pscore' ? 'ecogFormOptions'
        : key
      ] || filterData).forEach(val => {
        if (Array.isArray(formState[key]) && formState[key].includes(val.value))
          filtersSelected.push(val)
        else if (formState[key] === val.value) filtersSelected = val;
      })
      handleSelect(filtersSelected, key);
    }
  });
  currentForm.current = formState;

  return filterData.length > 0 ? <div style={styles.filterContainer}>
    <Form
      settings={formSettings}
      state={{formState: formState, setFormState: setFormState}}
      submitable={false}
    />
</div> : null
}

export default Filters;
